const urls = {
    EQUIPMENT_OPERATION: 'equipment-operation/tank',
    TANK_CONTENT: 'equipment-operation/tank-content',
    TANK: 'tank-management/tank',
    LAST_OPERATION: 'equipment-operation/last-operation',
    IMPORT_ECTV_PREVIEW: 'equipment-operation/import-ecvt-preview',
    IMPORT_ECTV_BY_TANK: 'equipment-operation/import-ecvt-by-tank',
    IMPORT_ECTV_BY_DATE_AND_SITE: 'equipment-operation/import-ecvt-by-date-and-site',
    COMBO_BIODIESEL_TANK: 'equipment-operation/combo-biodiesel-tank',
    CVT_DEVIATION: 'equipment-operation/cvt-deviation',
    IS_ACCERTAMENTO_PRODUZIONE: 'equipment-operation/is-accertamento-produzione-biodiesel-mix',
    CVT_DEVIATION_CALCULATE: 'equipment-operation/cvt-deviation-calculate',
    CVT_DEVIATION_SAVE: 'equipment-operation/cvt-deviation-save',
    CVT_DEVIATION_CHECK_TANK: 'equipment-operation/cvt-deviation-check',
    IS_AZZERAMENTO_PIEDE_CVT: 'equipment-operation/cvt-deviation-is-azzeramento-piede-cvt',
    IMPORT_FROM_PI: 'osipi/read-by-tank-and-date',
    READ_FROM_PI_BY_TAG_AND_DATE: 'osipi/read-by-tag-and-date',
    PI_ENVIRONMENT_TEMPERATURE: 'osipi/environment-temperature',
    MEASURE_LIST_BY_ID_SCHEDULED_OPERATION: 'equipment-operation/measures-list-by-id-scheduled-operation',
    FIXED_BALANCE_SPLIT: 'equipment-operation/fixed-balance-split',
    TANK_OPERATION_REPORT: 'equipment-operation/tank-print-report',
    TANK_OPERATION_REPORT_EXCEL: 'equipment-operation/tank-print-report-excel',

    CHECK_MOVED_QUANTITIES_SIGN: 'equipment-operation/check-moved-quantities-sign',

    GET_AUTOCOMPLETE_TANK_CALCULATION_VALUES: 'equipment-operation/tank-get-autocomplete-tank-calculation-values',

    LIMS_ADVANCED_SEARCH: 'equipment-operation/lims-advanced-search',
    LIMS_ADVANCED_SEARCH_COMPLETE_LIST: 'equipment-operation/lims-advanced-search-complete-list',
    LIMS_CONVERT_WATER_AND_SEDIMENTS: 'equipment-operation/lims-convert-water-and-sediments',

    CVT_REPORT_TANKS: 'equipment-operation/get-tank-report-cvt',
    CVT_REPORT_LOAD: 'equipment-operation/load-report-tank-cvt',
    CVT_REPORT_EXCEL: 'equipment-operation/report-tank-cvt-excel',
    CVT_REPORT_DOWNLOAD_EXCEL: 'equipment-operation/report-tank-cvt-print-excel',
    CVT_DEVIATION_EXCEL: 'equipment-operation/cvt-deviation-excel',
    CVT_DEVIATION_EXCEL_PRINT: 'equipment-operation/print-cvt-deviation-excel',

    DENATURANT_BULK_REGISTRY: 'equipment-operation/denaturant-registry-bulk',
    DENATURANT_BULK_REGISTRY_IMPORT: 'equipment-operation/denaturant-bulk-registry-import',
    DENATURANT_BULK_REGISTRY_RECHARGE: 'equipment-operation/denaturant-bulk-registry-recharge',
    DENATURANT_BULK_GET_CAPACITY: 'masterdata/denaturant-bulk-capacity-get-by-plant-and-product',
    DENATURANT_BULK_SUMMARY: 'equipment-operation/denaturant-bulk-summary',

    CHECK_OPERATIONS_TANK: 'equipment-operation/operations-rules',
    INFOIL_DEVIATION_CHECK_DATA: 'equipment-operation/get-infoil-deviation-check-data-single-tank',
    TANK_OPERATION_TANK_INFO: 'equipment-operation/tank-content-tank-information'
}

import genericService from '../genericService';

export default {
    async getOperations(body, callback){
        await genericService.get(urls.EQUIPMENT_OPERATION, body).then(callback);
    },
    async getOperation(id, callback){
        await genericService.getItem(urls.EQUIPMENT_OPERATION, id).then(callback);
    },
    async saveOperation(body, callback){
        await genericService.put(urls.EQUIPMENT_OPERATION, body).then(callback);
    },
    async createOperation(body, callback){
        await genericService.post(urls.EQUIPMENT_OPERATION, body).then(callback);
    },
    async getTankContent(body, callback){
        await genericService.getItem(urls.TANK_CONTENT, body).then(callback);
    },
    async getTankContentGrid(body, callback){
        await genericService.get(urls.TANK_CONTENT, body).then(callback);
    },
    async getTank(id, callback){
        await genericService.getItem(urls.TANK, id).then(callback);
    },
    async getLastOperation(body, callback){
        await genericService.get(urls.LAST_OPERATION, body).then(callback);
    },
    async getEctvPreview(body, callback){
        await genericService.get(urls.IMPORT_ECTV_PREVIEW, body).then(callback);
    },
    async importEcvtByTank(body, callback){
        await genericService.post(urls.IMPORT_ECTV_BY_TANK, body).then(callback);
    },
    async importEcvtByDateAndSite(body, callback){
        await genericService.post(urls.IMPORT_ECTV_BY_DATE_AND_SITE, body).then(callback);
    },
    async getBiodieselTankCombo(body, callback){
        await genericService.get(urls.COMBO_BIODIESEL_TANK, body).then(callback);
    },
    async getCVTDeviation(body, callback){
        await genericService.get(urls.CVT_DEVIATION, body).then(callback);
    },
    async getIsAccertamentoProduzione(body, callback){
        await genericService.get(urls.IS_ACCERTAMENTO_PRODUZIONE, body).then(callback);
    },
    async calculateCVTDeviation(body, callback){
        await genericService.post(urls.CVT_DEVIATION_CALCULATE, body).then(callback);
    },
    async saveCVTDeviation(body, callback){
        await genericService.post(urls.CVT_DEVIATION_SAVE, body).then(callback);
    },
    async checkTankCvtDeviation(body, callback){
        await genericService.get(urls.CVT_DEVIATION_CHECK_TANK, body).then(callback);
    },
    async getIsAzzeramentoPiedeCVT(body, callback){
        await genericService.get(urls.IS_AZZERAMENTO_PIEDE_CVT, body).then(callback);
    },
    async importFromPI(body, callback){
        await genericService.get(urls.IMPORT_FROM_PI, body).then(callback);
    },
    async readFromPiByTagAndDate(body, callback){
        await genericService.get(urls.READ_FROM_PI_BY_TAG_AND_DATE, body).then(callback);
    },
    async getEnvironmentTemperature(body, callback){
        await genericService.get(urls.PI_ENVIRONMENT_TEMPERATURE, body).then(callback);
    },
    async getMeasureListByIdScheduledOperation(id, callback){
        await genericService.get(urls.MEASURE_LIST_BY_ID_SCHEDULED_OPERATION + '/' + id, {}).then(callback);
    },
    async fixedBalanceSplit(body, callback){
        await genericService.post(urls.FIXED_BALANCE_SPLIT, body).then(callback);
    },
    async checkMovedQuantitiesSign(body, callback){
        await genericService.post(urls.CHECK_MOVED_QUANTITIES_SIGN, body).then(callback);
    },
    async getAutocompleteTankCalculationValues(body, callback){
        await genericService.get(urls.GET_AUTOCOMPLETE_TANK_CALCULATION_VALUES, body).then(callback);
    },
    async getLimsAdvancedSearch(body, callback){
        await genericService.get(urls.LIMS_ADVANCED_SEARCH, body).then(callback);
    },
    async getLimsAdvancedSearchCompleteList(body, callback){
        await genericService.get(urls.LIMS_ADVANCED_SEARCH_COMPLETE_LIST, body).then(callback);
    },
    async convertWaterAndSediments(body, callback){
        await genericService.get(urls.LIMS_CONVERT_WATER_AND_SEDIMENTS, body).then(callback);
    },
    async printTankOperationReport(body, callback){
        await genericService.dowloadFile(urls.TANK_OPERATION_REPORT, body).then(callback);
    },
    async printTankOperationReportExcel(body, callback){
        await genericService.dowloadFile(urls.TANK_OPERATION_REPORT_EXCEL, body).then(callback);
    },
    async getCVTReportTanks(body, callback){
        await genericService.get(urls.CVT_REPORT_TANKS, body).then(callback);
    },
    async getCVTReportLoad(body, callback){
        await genericService.post(urls.CVT_REPORT_LOAD,  body).then(callback);
    },
    async getCVTReportExcel(body, callback){
        await genericService.post(urls.CVT_REPORT_EXCEL,  body).then(callback);
    },
    async getCVTReportExcelDownload(id, callback){
        await genericService.dowloadFilePathVariable(urls.CVT_REPORT_DOWNLOAD_EXCEL, id).then(callback);
    },
    async getDeviationCVTExcel(body, callback){
        await genericService.post(urls.CVT_DEVIATION_EXCEL,  body).then(callback);
    },
    async getDeviationCVTExcelDownload(id, callback){
        await genericService.dowloadFilePathVariable(urls.CVT_DEVIATION_EXCEL_PRINT, id).then(callback);
    },
    async importDenaturatedOperations(body, callback){
        await genericService.post(urls.DENATURANT_BULK_REGISTRY_IMPORT, body).then(callback);
    },
    async addExtractionOperation(body, callback){
        await genericService.post(urls.DENATURANT_BULK_REGISTRY, body).then(callback);
    },
    async updateDenaturantBulkOperation(body, callback){
        await genericService.put(urls.DENATURANT_BULK_REGISTRY, body).then(callback);
    },
    async rechargeDenaturantBulk(body, callback){
        await genericService.post(urls.DENATURANT_BULK_REGISTRY_RECHARGE, body).then(callback);
    },
    async getDenaturantBulkCapacityByPlantAndProduct(body, callback){
        await genericService.get(urls.DENATURANT_BULK_GET_CAPACITY, body).then(callback);
    },
    async getDenaturantBulkSummary(callback){
        await genericService.get(urls.DENATURANT_BULK_SUMMARY, {}).then(callback);
    },
    async checkOperationTank(body, callback){
        await genericService.get(urls.CHECK_OPERATIONS_TANK, body).then(callback);
    },
    async getInfoilDeviationCheckDataSingleTank(body, callback){
        await genericService.get(urls.INFOIL_DEVIATION_CHECK_DATA, body).then(callback);
    },
    async equipmentOperationTankInfo(body, callback){
        await genericService.get(urls.TANK_OPERATION_TANK_INFO, body).then(callback);
    }
}